import { render, staticRenderFns } from "./index.vue?vue&type=template&id=44d8c04e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d8c04e')) {
      api.createRecord('44d8c04e', component.options)
    } else {
      api.reload('44d8c04e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=44d8c04e", function () {
      api.rerender('44d8c04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Customers/Stock/index.vue"
export default component.exports